import { CodigoApi as Api } from "./codigo.api";

export class CodigoFacade {
    static create(data) {
        return Api.create(data);
    }
    static update(data) {
        return Api.update(data);
    }
    static deleteById(id) {
        return Api.deleteById(id);
    }

    static uploadFileAlta(beneficioId, formData) {
        return Api.uploadFileAlta(beneficioId, formData);
    }
    
    static uploadFileBaja(beneficioId, formData) {
        return Api.uploadFileBaja(beneficioId, formData);
    }


}